import React, { useState } from "react";
import {
    GridRenderEditCellParams,
    useGridApiContext,
} from "@mui/x-data-grid-premium";
import TextField from "@mui/material/TextField";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import { Base } from "../../../framework/base";

/**
 * Edit cell for duration in hours + minutes.
 * Stores the value as decimal hours (e.g. 7.5 = 7h 30min).
 */
export const MuiDataGridDurationCell = ({
    id,
    field,
    value,
}: GridRenderEditCellParams) => {
    const apiRef = useGridApiContext();
    const numValue = (typeof value === "number" ? value : 0);
    const [hours, setHours] = useState(Math.floor(numValue));
    const [minutes, setMinutes] = useState(Math.round(Base.hoursToMinutes(numValue % 1)));

    const updateValue = (h: number, m: number) => {
        const decimal = h + m / 60;
        void apiRef.current.setEditCellValue({ id, field, value: decimal });
    };

    return (
        <Box sx={{ display: "flex", alignItems: "center", gap: 0.25, px: 0.5, width: "100%" }}>
            <TextField
                type="number"
                size="small"
                variant="standard"
                value={hours}
                inputProps={{ min: 0, style: { textAlign: "center", padding: 0 } }}
                onChange={(e) => {
                    const h = Math.max(0, parseInt(e.target.value) || 0);
                    setHours(h);
                    updateValue(h, minutes);
                }}
                sx={{ width: 35 }}
            />
            <Typography variant="caption" sx={{ color: "text.secondary" }}>h</Typography>
            <TextField
                type="number"
                size="small"
                variant="standard"
                value={minutes}
                inputProps={{ min: 0, max: 59, style: { textAlign: "center", padding: 0 } }}
                onChange={(e) => {
                    const m = Math.min(59, Math.max(0, parseInt(e.target.value) || 0));
                    setMinutes(m);
                    updateValue(hours, m);
                }}
                sx={{ width: 35 }}
            />
            <Typography variant="caption" sx={{ color: "text.secondary" }}>min</Typography>
        </Box>
    );
};
